import * as factory from '../../../iawp/src/js/factory'
import { Fancybox } from '@fancyapps/ui'


new factory.IAInit()

// Swiper News
if (!!document.querySelector('.ia-block-dates-slide.swiper-container')) {
    document.querySelectorAll('.ia-block-dates-slide.swiper-container').forEach((swiperElem) => {
        let s = new factory.IASwiper(swiperElem, {
            autoplay: false,
            watchSlidesProgress: true,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                641: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 2.9,
                    spaceBetween: 50,       
                }
            }
        })
    })
}

// Swiper Certified
if (!!document.querySelector('.ia-block-certified.swiper-container')) {
    document.querySelectorAll('.ia-block-certified.swiper-container').forEach((swiperElem) => {
        let s = new factory.IASwiper(swiperElem, {
            autoplay: false,
            watchSlidesProgress: true,
            watchOverflow: true,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                641: {
                    slidesPerView: 4.2,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 6.2,
                    spaceBetween: 16,
                }
            }
        })
    })
}

// Menu de navigation
document.querySelectorAll('.ia-block-navigation--main .menu-item-has-children > a').forEach((menuItem, index) => {
    menuItem.addEventListener('click', (e)=>{
        e.preventDefault()
        const menuItemClicked = e.target.parentElement;
        if(document.querySelector('.ia-block-navigation--main .sub-menu.is-active') == menuItemClicked.querySelector('.sub-menu')){
            menuItemClicked.querySelector('.sub-menu').classList.remove('is-active')
        }else {
            if(document.querySelector('.ia-block-navigation--main .sub-menu.is-active')){
                document.querySelector('.ia-block-navigation--main .sub-menu.is-active').classList.remove('is-active')
            }
            menuItemClicked.querySelector('.sub-menu').classList.add('is-active')
        }
    })
})

document.querySelectorAll('.js-ia-blocks-form').forEach(form=>{
    console.log(form);
    new factory.IAForm(form, true, {
        rules:{},
        messagesIdClass: '.contactForm'  
    });
})
factory.$(document).ready(function(){
    if(factory.$('.ia-block-slider-youtube').length){
        factory.$('.ia-block-slider-youtube').each(function () {
    
            var swiperSlider = new Swiper(factory.$(this), {
                speed: 400,
                watchOverflow: true,
                spaceBetween: 20,
    
                slidesPerView: 1,
                navigation: {
                    nextEl: factory.$(this).find('.swiper-button-next'),
                    prevEl: factory.$(this).find('.swiper-button-prev'),
                },
            });
        })
    }
})

// Photos gallery
if (factory.$('.is-gallery .wp-block-gallery').length) {

    factory.$('.is-gallery .wp-block-gallery').find('.wp-block-image').each(function(){
        factory.$(this).addClass('swiper-slide');
        if (factory.$(this).find('a').length) {
            factory.$(this).find('a').attr('data-fancybox', "gallery");
        };
    });
    
    Fancybox.bind('[data-fancybox="gallery"]');
}

if(factory.$('[data-fancybox="video-gallery"]').length){
    Fancybox.bind('[data-fancybox="video-gallery"]');
}

//MATOMO
// const matomoParagraph = document.querySelector('#matomo_opted_in_intro');
// const formElement = matomoParagraph.nextElementSibling;
// if (formElement.tagName === 'FORM') {
//     formElement.classList.add('matomo_checkbox');
// }